import { IonItemDivider, IonLabel } from "@ionic/react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";

import { Template } from "../../../@types/template";
import { findTemplatesAssignedToUser } from "../../../store/templateList/actions/findTemplatesAssignedToUser";
import { selectTemplateForUserList } from "../../../store/templateList/selectors/selectTemplatesForUserList";
import { UserTemplateItem } from "./UserTemplateItem";


export const UserTemplateListContainer = () => {
  const { id }: { id: string } = useParams();
  const dispatch = useDispatch();
  const userTemplateList = useSelector(selectTemplateForUserList);

  useEffect(() => {
    dispatch(findTemplatesAssignedToUser({user: id}));
  }, [dispatch]);
  
  return (
    <>
      <IonItemDivider class="ion-margin-bottom">
        <IonLabel>
          <p>{userTemplateList.length} resultados</p>
        </IonLabel>
      </IonItemDivider>
      {userTemplateList.map((template: Template) => (
        <UserTemplateItem key={template.id} template={template} />
      ))}
    </>
  );
};
